module.exports = __webpack_public_path__ + "45bc65466f93ee7c3df5817a57767bd6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SR.svg
// module id = KYT4
// module chunks = 0